import Button from "@/common/button/button"
import { useActiveStep } from "../store"

function SubmitStepButton({ overrideDisabled = false }) {
  const { buttonText } = useActiveStep()

  return (
    <div className="flex ">
      <Button
        theme="lime"
        ariaLabel={buttonText || "Nästa"}
        className="flex-grow mx-auto md:flex-grow-0 submit-step-button"
        type="submit"
        disabled={overrideDisabled}>
        {buttonText || "Nästa"}
      </Button>
    </div>
  )
}

export default SubmitStepButton
